// @flow
import {Layout} from 'modules/common/components/Layout';
import React from 'react';

/**
 * Тестовая страница для демонстрации работы header и контентной части
 * @returns React-компонент
 */
export const TestPage = () => {
    return (
        <Layout>
            <div className="container">
                <h1 className="m-b_m">Контент</h1>
                <div className="row with-wrap m-b_m">
                    <div className="col-6">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab consequatur et, maiores nemo officiis sunt!</h2>
                    </div>
                    <div className="col-6">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur ducimus eligendi eum iusto obcaecati quod.</h2>
                    </div>
                    <div className="col-6">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut consequatur esse et hic natus suscipit?</h2>
                    </div>
                    <div className="col-6">
                        <h2>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab aliquid atque dignissimos officia ut veniam!</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Delectus eligendi fuga hic odio possimus sequi! Lorem ipsum
                            dolor sit amet, consectetur adipisicing elit. Delectus eligendi fuga hic odio possimus sequi!
                        </h2>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
